import { TEMP_DASHBOARD_URL } from "../constants";

export const getDrilldownUrl = (dashboardType, id) => `${TEMP_DASHBOARD_URL[dashboardType]}${id}`;
export const openNewTab = (url) => window.open(`${url}`, '_blank', 'noopener,noreferrer');

